// import Swiper core and required modules
import { Navigation, A11y } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import { collectionFilter } from '../../mixins/collectionFilter';
import { size } from '../../mixins/size';
import reviewStars from '../../yotpo-reviews/review-stars/review-stars.vue';

export default {
  name: 'uptProductCard',
  components: {
    Swiper,
    SwiperSlide,
    ReviewStars: reviewStars,
  },
  props: [
    'product', 
    'heroBackground', 
    'bundleBuilder', 
    'groupMaxMet',
    'discountType',
    'minDiscount',
    'allGroupsHaveOneProduct'
  ],
  mixins: [collectionFilter, size],
  setup() {
    const onSwiper = () => {};
    const onSlideChange = () => {};
    return {
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, A11y],
    };
  },
  data() {
    return {
      activeSize: null,
      inBundle: false,
      productHasSize: null,
      quantityInBundle: 0,
      sizeDrawerOpen: false,
      starSize: 'small',
    };
  },
  watch: {
    //changes the product's in-bundle status when it is added or removed from the bundle
    bundleBuilder: {
      handler(newValue, oldValue) {
        if (!this.product || !this.product.title) {
          return;
        }
        const productInNewBundle = newValue.find(
          (item) => item.productName == this.product.title
        );

        if (productInNewBundle) {
          this.inBundle = true;
          //determine how many times product exists in bundle to update quantityInBundle
          this.quantityInBundle = this.countBundleItems(this.bundleBuilder);
        } else {
          this.inBundle = false;
          //if item is not in bundle, set qualityInBundle back to 0
          this.quantityInBundle = 0;
        }
      },
      deep: true,
    },
  },
  computed: {
    formattedStarSize() {
      let screenWidth =
        window.innerWidth > 0 ? window.innerWidth : screen.width;

      if (screenWidth < 768) {
        return (this.starSize = 'tiny');
      } else {
        return;
      }
    },
    currentSizes() {
      //find the colorway with the same name as the current active color
      const selectedColorway = this.product.colorways.find(
        (color) => color.name === this.product.activeColor
      );
      //drill down into the size array of selected color
      const currentSizes = selectedColorway.sizes;

      return currentSizes;
    },
  },
  methods: {
    countBundleItems(bundleArr) {
      let count = 0;
      bundleArr.forEach((item) => {
        if (item.productName === this.product.title) {
          count++;
        }
      });
      return count;
    },
    // format price
    formatPrice(price) {
      let currency = '$';
      //let formattedPrice = (price/100).toString(); // will return a whole number if no decimal is present.
      if (price.includes('.')) {
        // if we have decimal data, make sure it is 2 decimal places deep (for sezzle widget)
        price = parseFloat(price).toFixed(2).toString();
        price = price.replace('.00', '');
        // let strippedPrice = price.substr(price.length - 3)
        // if (strippedPrice === '.00'){
        // 	price
        // }
      }
      //added the turnary operator at the end for an EU legal requirement. #excludes adding this extra text to gift-cards 10/12/2020
      return `${currency}${price}`;
    },
    percentageSavings(theprice, thecompare) {
      let savings = Math.round((theprice / thecompare) * 100);
      return 100 - savings;
    },

    addProductToBundle() {
      //check if product even has size first then
      if (!this.activeSize && this.productHasSize === true) {
        this.sizeDrawerOpen = true;
      } else {
        //sends product data to container to add product to bundle
        this.$emit('add-to-bundle', this.product);
      }
    },

    updateActiveSize(size) {
      this.activeSize = size;
      this.product.activeSize = size.name;
      this.sizeDrawerOpen = false;
    },

    doesProductHaveSize() {
      const selectedColorway = this.product.colorways.find(
        (color) => color.name === this.product.activeColor
      );
      if (selectedColorway.sizes.length === 1) {
        if (selectedColorway.sizes[0].name == 'null') {
          this.productHasSize = false;
          this.product.activeSize = 'null';
        } else {
          //if product only has 1 colorway, for example Cubos, auto select the one size
          this.productHasSize = true;
          this.activeSize = selectedColorway.sizes[0];
        }
      } else {
        this.productHasSize = true;
        this.sortSizeArray(selectedColorway);
      }
    },

    updateColorway(
      color,
      img,
      product,
      isDelDia,
      price,
      comparePrice,
      status = ''
    ) {
      product.activePrice = price.toString();
      product.activeCompareAtPrice = comparePrice.toString();
      if (isDelDia === false) {
        product.featuredImage = img;
      }
      product.isDelDia = isDelDia;
      product.activeColor = color;
      product.colorwayStatus = status;

      //set active size to current colorway data for availability
      if (this.activeSize) {
        const currentColorway = this.product.colorways.find(
          (cw) => cw.name === color
        );

        const newSize = currentColorway.sizes.find(
          (sz) => sz.name === this.activeSize.name
        );
        this.activeSize = newSize;
      }

      this.$forceUpdate(); //this is used to get images to swap when the del dia color swatch is clicked.
    },
  },
  beforeMount() {
    this.doesProductHaveSize();
    //this.setActiveSize();
  },
};
